// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2koJO","col":"styles_col__qrf7d","actions":"styles_actions__3Qjb3","conflict":"styles_conflict__1oj2H"};